import Image from "next/image";
import BasicBlock from "../shared/basic-block";
import CTAButton from "./CTAButton";
import { CDN_URL } from "@/consts";

const AutoClipperHeader = (
  <h3 className="text-center text-[42px] font-semibold leading-[1.1] md:text-[48px]">
    Turn one long video into viral-ready <br /> clips in a fraction of the time.
  </h3>
);

const AutoClipperSection = () => {
  return (
    <BasicBlock
      header={AutoClipperHeader}
      contentStyle="items-center justify-center flex-col gap-6"
    >
      <Image
        src={`${CDN_URL}/landing/autoclipper.png`}
        alt="Auto Clipper"
        width={2400}
        height={1306}
        draggable={false}
        className="w-full rounded-2xl"
      />
      <CTAButton />
    </BasicBlock>
  );
};

export default AutoClipperSection;
